<template lang="pug">
  el-dialog.quotation-detail(
    :visible="visible"
    :title="$t('历史记录')"
    @close="$emit('closeDialog')"
    width="900px"
    :close-on-click-modal="true"
    center
  )
    unistar-tables(
      :starData="tableData"
    )

</template>

<script>
import TitleBar from '@/components/TitleBar'
import UnistarTables from '@/components/UnistarTables'
export default {
  components: {
    TitleBar,
    UnistarTables
  },
  computed: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style lang="stylus">

</style>
